module.exports = __webpack_public_path__ + "img/right.13e14c20.svg";